var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessageB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34436 11.7288C6.28221 11.3282 6.24996 10.9179 6.24996 10.5C6.24996 6.08172 9.85525 2.5 14.3026 2.5C18.7499 2.5 22.3552 6.08172 22.3552 10.5C22.3552 11.4981 22.1713 12.4535 21.8352 13.3345C21.7654 13.5175 21.7304 13.609 21.7146 13.6804C21.6989 13.7512 21.6928 13.801 21.6911 13.8735C21.6894 13.9466 21.6993 14.0272 21.7192 14.1883L22.1217 17.4585C22.1653 17.8125 22.1871 17.9895 22.1282 18.1182C22.0766 18.231 21.985 18.3205 21.8711 18.3695C21.7411 18.4254 21.5646 18.3995 21.2117 18.3478L18.0265 17.8809C17.8601 17.8565 17.777 17.8443 17.7012 17.8448C17.6263 17.8452 17.5745 17.8507 17.5011 17.8661C17.427 17.8817 17.3323 17.9172 17.143 17.9881C16.2597 18.319 15.3024 18.5 14.3026 18.5C13.8844 18.5 13.4737 18.4683 13.0727 18.4073M7.88158 22.5C10.8465 22.5 13.25 20.0376 13.25 17C13.25 13.9624 10.8465 11.5 7.88158 11.5C4.91668 11.5 2.51316 13.9624 2.51316 17C2.51316 17.6106 2.61028 18.1979 2.78955 18.7467C2.86533 18.9787 2.90322 19.0947 2.91566 19.1739C2.92864 19.2567 2.93091 19.3031 2.92608 19.3867C2.92145 19.4668 2.90141 19.5573 2.86134 19.7383L2.25 22.5L5.2448 22.091C5.40827 22.0687 5.49 22.0575 5.56137 22.058C5.63652 22.0585 5.67641 22.0626 5.75011 22.0773C5.8201 22.0912 5.92416 22.1279 6.13227 22.2014C6.68059 22.3949 7.26911 22.5 7.88158 22.5Z",
    stroke: "#0C1A40",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageB);
export default __webpack_public_path__ + "static/media/message-b.b5a821a22bb8c650699ed6dc8c3037c8.svg";
export { ForwardRef as ReactComponent };